<!--table-->
<div class="custom-scrollbar">
  <perfect-scrollbar>
    <table class="table-list table-box">
      <thead>
      <tr>
        <th>{{ tabName === 'DEALER' ? ([companies.SeaIm].includes(company) ? 'Company' : 'Dealer') : 'Agent Name' }}</th>
        <th>{{ tabName === 'DEALER' ? ([companies.SeaIm].includes(company) ? 'Address' : 'Store') : 'Email' }}</th>
        <th>Total</th>
        <ng-container *ngIf="tabName === 'DEALER' && [companies.Sea].includes(company)">
          <th>Open Tickets</th>
          <th>Closed Tickets</th>
        </ng-container>
        <ng-container *ngIf="tabName === 'DEALER' && [companies.Seca].includes(company)">
          <th>Request Pending</th>
          <th>Long Term Pending</th>
          <th>Request Approved</th>
          <th>Repair In Progress</th>
          <th>Repair Completed</th>
          <th>Repair Canceled</th>
          <th>Request Canceled</th>
        </ng-container>
        <ng-container *ngIf="tabName === 'DEALER' && [companies.SeaIm].includes(company)">
          <th>Draft</th>
          <th>Pending</th>
          <th>Completed</th>
          <th>Canceled</th>
        </ng-container>
        <ng-container *ngIf="tabName === 'AGENT' && [companies.Sea].includes(company)">
          <th>Assigned to Service Center</th>
          <th>Acknowledge(Service Center)</th>
          <th>Technician Assigned</th>
          <th>Pending</th>
          <th>Service Center not available</th>
          <th>Service Center decline</th>
          <th>Completed</th>
          <th>Canceled</th>
        </ng-container>
        <ng-container *ngIf="tabName === 'AGENT' && [companies.Seca].includes(company)">
          <th>Request Pending</th>
          <th>Long Term Pending</th>
          <th>Request Approved</th>
          <th>Repair In Progress</th>
          <th>Repair Completed</th>
          <th>Repair Canceled</th>
          <th>Request Canceled</th>
        </ng-container>
        <ng-container *ngIf="tabName === 'AGENT' && [companies.SeaIm].includes(company)">
          <th>Draft</th>
          <th>Pending</th>
          <th>Completed</th>
          <th>Canceled</th>
        </ng-container>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let summary of summaryStatusData; let i=index;"
          class="shadow-sm">
        <td>{{ tabName === 'DEALER' ? summary.dealerName : summary.agentName || '' }}</td>
        <td>{{ tabName === 'DEALER' ? summary.dealerStoreName : summary.username }}</td>
        <td class="number-td">
          <div class="number">{{ summary.total | number: '1.0-0' }}</div>
        </td>
        <ng-container *ngIf="tabName === 'DEALER' && [companies.Sea].includes(company)">
          <td class="number-td">
            <div class="number">{{ summary.opened | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.closed | number: '1.0-0' }}</div>
          </td>
        </ng-container>
        <ng-container *ngIf="tabName === 'DEALER' && [companies.Seca].includes(company)">
          <td class="number-td">
            <div class="number">{{ summary.requestPending | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.longTermPending | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.requestApproved | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.repairInProgress | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.repairCompleted | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.repairCanceled | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.requestCanceled | number: '1.0-0' }}</div>
          </td>
        </ng-container>
        <ng-container *ngIf="tabName === 'DEALER' && [companies.SeaIm].includes(company)">
          <td class="number-td">
            <div class="number">{{ summary.draft | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.pending | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.completed | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.canceled | number: '1.0-0' }}</div>
          </td>
        </ng-container>
        <ng-container *ngIf="tabName === 'AGENT' && [companies.Sea].includes(company)">
          <td class="number-td">
            <div class="number">{{ summary.assignedToAsc | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.acknowledgeAsc | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.engineerAssigned | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number red">{{ summary.pending | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number red">{{ summary.ascNotAvailable | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number red">{{ summary.ascDecline | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.completed }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.canceled }}</div>
          </td>
        </ng-container>
        <ng-container *ngIf="tabName === 'AGENT' && [companies.Seca].includes(company)">
          <td class="number-td">
            <div class="number">{{ summary.requestPending | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.longTermPending | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.requestApproved | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.repairInProgress | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.repairCompleted | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.repairCanceled | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.requestCanceled | number: '1.0-0' }}</div>
          </td>
        </ng-container>
        <ng-container *ngIf="tabName === 'AGENT' && [companies.SeaIm].includes(company)">
          <td class="number-td">
            <div class="number">{{ summary.draft | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.pending | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.completed | number: '1.0-0' }}</div>
          </td>
          <td class="number-td">
            <div class="number">{{ summary.canceled | number: '1.0-0' }}</div>
          </td>
        </ng-container>
      </tr>
      </tbody>
    </table>
    <div *ngIf="!summaryStatusData?.length" class="align-center">
      <font-awesome [icon]="'fa-light fa-file-circle-exclamation'"></font-awesome>
      <span class="pl-14px">No results found</span>
    </div>
  </perfect-scrollbar>
</div>
